<template>
  <crud-form
    v-model="payload"
    :page-title="$t('app.useterms.add')"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="UseTerms"
    navigate-page-after-save="UseTerms"
    remove-cancel
    :override-success-toas-message-create="$t('app.useterms.successMessage')"
    :override-after-save="overrideAfterSave"
  >
    <template slot="group-1">
      <form-group :title="$t('app.useterms.form.subtitle')">
        <v-flex
          xs12
          lg6
        >
          <input-text
            id="urlField"
            v-model="payload.url"
            required
            :label="$t('app.useterms.form.url')"
            :loading="loading"
          />
          <input-text
            id="versionField"
            v-model="payload.versaoDoDocumento"
            required
            :rules="[maxNumberLength(3)]"
            :label="$t('app.useterms.form.version')"
            :loading="loading"
            @keypress="onlyNumber($event)"
          />
        </v-flex>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import InputText from 'Support/components/inputs/InputText.vue';
import FormGroup from 'Support/layout/FormGroup.vue';
import CrudForm from 'Support/components/crud/CrudForm.vue';
import UseTermsRequest from 'Domain/useterms/UseTermsRequest';
import RulesMixin from 'Support/mixins/rules-mixin';
import NumberMixin from 'Support/components/lists/mixins/number.mixin';

export default {
  name: 'UseTermsForm',
  components: {
    CrudForm,
    FormGroup,
    InputText,
  },
  mixins: [RulesMixin, NumberMixin],
  data: () => ({
    requestClass: UseTermsRequest,
    payload: {
      id: '',
      url: '',
      versaoDoDocumento: '',
    },
    loading: false,
  }),
  created() {
    this.getData();
  },
  methods: {
    overrideAfterSave() {
      this.getData();
    },
    getData() {
      this.loading = true;
      UseTermsRequest
        .getTerms()
        .then(({ data }) => {
          this.payload = {
            id: data.id,
            url: data.url,
            versaoDoDocumento: data.versaoDoDocumento,
          };
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
